import { useRef, useCallback } from "react";

const MUI_COLLAPSE_DURATION_MS = 300;

export const useScrollOnExpand = () => {
  const blockRef = useRef<HTMLDivElement>(null);

  const handleExpandWithScroll = useCallback((onExpand: () => void) => {
    onExpand();

    setTimeout(() => {
      if (!blockRef.current) return;

      const blockRect = blockRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (blockRect.bottom > viewportHeight) {
        blockRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, MUI_COLLAPSE_DURATION_MS);
  }, []);

  return { blockRef, handleExpandWithScroll };
};
